// extracted by mini-css-extract-plugin
module.exports = {"emphasizedLink":"index-module--emphasized-link--36KGt","lastUpdate":"index-module--lastUpdate--3mM-b","schedule":"index-module--schedule--3PsiB"};